import { SelectOption } from 'components/inputs/BaseSelect';

export const Languages: Record<string, Array<string>> = {
  'de-DE': ['Deutsch', '(DE)'],
  'en-AU': ['English', '(AUS)'],
  'en-GB': ['English', '(UK)'],
  'en-US': ['English', '(US)'],
  'sv-SE': ['Svenska', '(SE)'],
};

export const languageOptions = Object.entries(Languages).map(
  (language): SelectOption => ({
    label: language[1][0],
    description: language[1][1],
    value: language[0],
  })
);
